import { render, staticRenderFns } from "./LicenseCheckZbperson.vue?vue&type=template&id=bbeafaa0&scoped=true&"
import script from "./LicenseCheckZbperson.vue?vue&type=script&lang=js&"
export * from "./LicenseCheckZbperson.vue?vue&type=script&lang=js&"
import style0 from "./LicenseCheckZbperson.vue?vue&type=style&index=0&id=bbeafaa0&scoped=true&lang=css&"
import style1 from "./LicenseCheckZbperson.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbeafaa0",
  null
  
)

export default component.exports